import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render how do i know section for FAQ Page
 */
const HowDoIKnowSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="how-do-i-know-section-component"
    >
      <AccordionV2
        testId="how-do-i-know"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="1. How will I know if I have been shortlisted?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 pb-2 pt-6">
          <p>
            The shortlisted applicants will be notified by email and phone by
            mid August 2026.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default HowDoIKnowSection;
